import React, { useState } from 'react';
import { Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import './expandStyle.scss';

const menuItems = [
  {
    label: 'Level 1',
    key: '0',
  },
  {
    label: 'Level 2',
    key: '1',
  },
  {
    label: 'Level 3',
    key: '2',
  },
];

function Expand({ collapseAll, expandPhase, expandAll }) {
  const [open, setOpen] = useState(false);
  const onMenuClick = ({ key }) => {
    switch (key) {
      case '0':
        collapseAll();
        break;
      case '1':
        expandPhase();
        break;
      case '2':
        expandAll();
        break;
    }
    setOpen(false);
  };
  const menu = (
    <Menu onClick={onMenuClick}>
      {menuItems.map((i) => (
        <Menu.Item key={i.key}>{i.label}</Menu.Item>
      ))}
    </Menu>
  );
  return (
    <div className="collapse-btn-wrapper">
      <Dropdown
        overlay={menu}
        trigger="click"
        onVisibleChange={setOpen}
        overlayClassName="lifecycle-expand-button-dropdown"
      >
        <a
          onClick={(e) => e.preventDefault()}
          className="lifecycle-expand-button"
        >
          Level Expand{' '}
          <DownOutlined className={`down-icon ${open ? 'rotate' : ''}`} />
        </a>
      </Dropdown>
    </div>
  );
}

export default Expand;
